if (!customElements.get("countdown-to.js")) {
  class CountdownTo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.interval = setInterval(() => {
        const target = Date.parse(this.closest("div").dataset.countdown);
        const now = new Date().getTime();

        const diff = target - now;

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        this.innerHTML = `
          <strong>${days}</strong>d
          <strong>${hours}</strong>h
          <strong>${minutes}</strong>m
          <strong>${seconds}</strong>s
        `;

        if (diff < 0) {
          clearInterval(this.interval);
          this.innerHTML = `
            <strong>0</strong>d
            <strong>0</strong>h
            <strong>0</strong>m
            <strong>0</strong>s
          `;
        }
      }, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  customElements.define("countdown-to", CountdownTo);
}
